import throttle from "lodash/throttle";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Directives
import Accordion from "./directives/accordion";
import FeatherlightGallery from "./directives/featherlight-gallery";
import FeatherlightVideo from "./directives/featherlight-video";
import ScrollTo from "./directives/scroll-to";
import StickyTop from "./directives/sticky-top";

Vue.directive("accordion", Accordion);
Vue.directive("featherlight-gallery", FeatherlightGallery);
Vue.directive("featherlight-video", FeatherlightVideo);
Vue.directive("scroll-to", ScrollTo);
Vue.directive("sticky-top", StickyTop);

// Shared elements
import LocationSearch from "./components/global/elements/LocationSearch";
import KeywordSearch from "./components/global/elements/KeywordSearch";
import NewsletterSubscribe from "./components/global/elements/NewsletterSubscribe";
import InlineLocationSearch from "./components/global/elements/InlineLocationSearch";
import Checkbox from "./components/global/forms/Checkbox";
import CheckboxPill from "./components/global/forms/CheckboxPill";
import DateSelectGroup from "./components/global/forms/DateSelectGroup";
import DocumentUploader from "./components/global/forms/DocumentUploader";
import InputError from "./components/global/forms/InputError";
import Litepicker from "./components/global/forms/Litepicker";
import Radio from "./components/global/forms/Radio";
import SelectWrapper from "./components/global/forms/SelectWrapper";
import WordCountTextarea from "./components/global/forms/WordCountTextarea";
import MediaUploader from "./components/global/forms/MediaUploader";
import AttachmentUploader from "./components/global/forms/AttachmentUploader";
import AutoCompleteAddress from "./components/global/forms/AutoCompleteAddress";
import InternalNav from "./components/global/nav/InternalNav";
import AddBriefButton from "./components/global/nav/AddBriefButton";
import BriefUsButton from "./components/global/nav/BriefUsButton";
import Sidebar from "./components/global/nav/Sidebar";
import AddListingLink from "./components/global/nav/AddListingLink";
import CreateBriefLink from "./components/global/nav/CreateBriefLink";
import ListYourSpaceButton from "./components/global/nav/ListYourSpaceButton";
import ListYourSpaceWhyUsButton from "./components/global/nav/ListYourSpaceWhyUsButton";
import LoginOrExploreButton from "./components/global/nav/LoginOrExploreButton";
import ByronEnquireNow from "./components/global/nav/ByronEnquireNow";
import AccountTable from "./components/global/tables/AccountTable";
import CalendarView from "./components/global/tables/CalendarView";
import Listing from "./components/global/tables/Listing";
import Pagination from "./components/global/tables/Pagination";
import ExpandyChildren from "./components/global/util/ExpandyChildren";
import ExpandyContent from "./components/global/util/ExpandyContent";
import Loader from "./components/global/util/Loader";
import LoaderButton from "./components/global/util/LoaderButton";
import PaymentTrustmarks from "./components/global/util/PaymentTrustmarks";
import SvgIcon from "./components/global/util/SvgIcon";
import ToastedAlert from "./components/global/util/ToastedAlert";
import StripeElementCard from "./components/global/elements/StripeElementCard";
import StripeSelectCard from "./components/global/elements/StripeSelectCard";
import SubscriptionSlider from "./components/global/others/SubscriptionSlider";
import FindYourSpaceButton from "./components/global/nav/FindYourSpaceButton";
import FindYourSpaceLink from "./components/global/nav/FindYourSpaceLink";

//Contact Button
import ContactButton from "./components/global/others/ContactButton";

Vue.component("location-search", LocationSearch);
Vue.component("keyword-search", KeywordSearch);
Vue.component("newsletter-subscribe", NewsletterSubscribe);
Vue.component("inline-location-search", InlineLocationSearch);
Vue.component("checkbox", Checkbox);
Vue.component("checkbox-pill", CheckboxPill);
Vue.component("date-select-group", DateSelectGroup);
Vue.component("document-uploader", DocumentUploader);
Vue.component("input-error", InputError);
Vue.component("litepicker", Litepicker);
Vue.component("radio", Radio);
Vue.component("select-wrapper", SelectWrapper);
Vue.component("word-count-textarea", WordCountTextarea);
Vue.component("media-uploader", MediaUploader);
Vue.component("attachment-uploader", AttachmentUploader);
Vue.component("auto-complete-address", AutoCompleteAddress);
Vue.component("internal-nav", InternalNav);
Vue.component("add-brief-button", AddBriefButton);
Vue.component("brief-us-button", BriefUsButton);
Vue.component("sidebar", Sidebar);
Vue.component("add-listing-link", AddListingLink);
Vue.component("create-brief-link", CreateBriefLink);
Vue.component("list-your-space-button", ListYourSpaceButton);
Vue.component("list-your-space-why-us-button", ListYourSpaceWhyUsButton);
Vue.component("login-or-explore-button", LoginOrExploreButton);
Vue.component("byron-enquire-now", ByronEnquireNow);
Vue.component("account-table", AccountTable);
Vue.component("calendar-view", CalendarView);
Vue.component("listing", Listing);
Vue.component("pagination", Pagination);
Vue.component("expandy-children", ExpandyChildren);
Vue.component("expandy-content", ExpandyContent);
Vue.component("loader", Loader);
Vue.component("loader-button", LoaderButton);
Vue.component("payment-trustmarks", PaymentTrustmarks);
Vue.component("svg-icon", SvgIcon);
Vue.component("toasted-alert", ToastedAlert);
Vue.component("stripe-card", StripeElementCard);
Vue.component("stripe-select-card", StripeSelectCard);
Vue.component("contact-button", ContactButton);
Vue.component("subscription-slider", SubscriptionSlider);
Vue.component("find-your-space-button", FindYourSpaceButton);
Vue.component("find-your-space-link", FindYourSpaceLink);

// Global panels/helpers that live in our root instance
import AuthControls from "./components/auth/AuthControls";
import AccountPanel from "./components/account/AccountPanel";
import AuthPanel from "./components/auth/AuthPanel";
import ModalList from "./components/global/util/ModalList";
import Impersonate from "./components/auth/Impersonate";
import SocialLogin from "./components/auth/SocialLogin";
import FindSpaceModal from "./components/modals/find-space/FindSpaceModal";

// Tabs
import Tab from "./components/tabs/Tab";
import Tabs from "./components/tabs/Tabs";

// Listings
import Listings from "./components/listings/Index";
import AvailabilityChecker from "./components/listings/bookings/AvailabilityChecker";
import BookActions from "./components/listings/bookings/BookActions";

// Shortlists
import SingleButton from "./components/shortlists/SingleButton";

// Pdf Button
import PdfButton from "./components/pdf/PdfButton";

// Blog (the recce)
import BlogArticles from "./components/blog/Index";
import IndustryNews from "./components/industry/Index";

// Simple bar
import VueSimplebar from "vue-simplebar";
import "vue-simplebar/dist/vue-simplebar.min.css";

Vue.use(VueSimplebar);

// Vueper Slides
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

Vue.component('vueper-slides', VueperSlides);
Vue.component('vueper-slide', VueperSlide);

// Vue Datepicker
import VueDatePicker from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

Vue.use(VueDatePicker);

// Toasted
import Toasted from "vue-toasted";

Vue.use(Toasted, {
    position: "top-center",
    duration: 6000,
});

// Floating vue
import { VTooltip } from "floating-vue";
import "floating-vue/dist/style.css";

Vue.directive("floating-tooltip", VTooltip);

// Vuex stores
const store = new Vuex.Store(require("./vuex.js").default);

// Event bus
Vue.prototype.$eventBus = new Vue();

// Mixins
import "./mixins/object-fill";

new Vue({
    el: "#app",
    components: {
        AuthControls,
        //Login,
        Tab,
        Tabs,
        Listings,
        AvailabilityChecker,
        BookActions,
        BlogArticles,
        IndustryNews,
        AccountPanel,
        AuthPanel,
        "modal-list": ModalList,
        "shortlist-button": SingleButton,
        "pdf-button": PdfButton,
        Impersonate,
        SocialLogin,
        FindSpaceModal,
    },
    config: {
        devtools: true,
    },
    store,
    computed: {
        intercomSettings() {
            return window.intercomSettings;
        },
        isHirer() {
            return this.$store.getters["user/isHirer"];
        },
        isLister() {
            return this.$store.getters["user/isLister"];
        },
        isLoggedIn() {
            return this.$store.getters["user/account"];
        },
        user() {
            return this.$store.getters["user/account"];
        },
    },
    watch: {
        user: {
            handler() {
                // Populate some data for Intercom
                if (window.intercomSettings) {
                    if (this.isLoggedIn) {
                        window.intercomSettings.user_id = this.user.id;
                        window.intercomSettings.user_hash = this.user.intercom_user_hash;
                        window.intercomSettings.email = this.user.email;
                        window.intercomSettings.name = this.user.first_name + " " + this.user.last_name;
                        window.intercomSettings.user_type = this.user_type;
                        window.intercomSettings.job_title = this.user.job_title;
                        window.intercomSettings.phone = this.user.phone;
                        window.intercomSettings.created_at = this.user.created_at;
                    } else {
                        delete window.intercomSettings.user_id;
                        delete window.intercomSettings.user_hash;
                        delete window.intercomSettings.email;
                        delete window.intercomSettings.name;
                        delete window.intercomSettings.user_type;
                        delete window.intercomSettings.job_title;
                        delete window.intercomSettings.phone;
                        delete window.intercomSettings.created_at;
                    }

                    if (window.Intercom) {
                        window.Intercom("update", window.intercomSettings);
                    }
                }
            },
            deep: true,
        },
    },
    beforeMount() {
      this.honeypot = JSON.parse(this.$el.attributes["data-honeypot"].value);
      this.social_login_urls = JSON.parse(
        this.$el.attributes["data-social-login-urls"].value
        );
      },
      mounted() {
        this.handleShowPublicShortlist();
        this.handleStripeOnBoardingReturns();
        this.handleDirectPanelNavigationQuery();
    },
    created() {
        // Auth check on startup
        // this.$store.dispatch('user/requireAuthentication')
        //   .then(() => {})
        //   .catch(() => {})

        // Show/hide elements which we've temporarily disabled while loading things
        document.body.classList.add("initialized");
        document.body.classList.remove("initializing");

        window.addEventListener("wheel", this.preventOverscroll, {
            passive: false,
        });

        // Subscribe to navigation mutations and emit global event
        this.$store.subscribe((mutation) => {
            if (
                mutation.type === "account/navigateTo" ||
                mutation.type === "account/navigateSubpage"
            ) {
                this.$eventBus.$emit("accountNavigate", mutation);
            }
        });

        // Track any page-level intercom event we might have
        if (intercomEvent) {
            this.$store.dispatch("intercom/track", intercomEvent);
        }
    },
    data() {
        return {
            images: {
                expanded: false,
            },

            menu: {
                show: null,
                hideTimeout: null,
                showTimeout: null,
            },

            search: {
                visible: false,
            },

            honeypot: null,

            social_login_urls: {
                google: null,
            },
        };
    },
    methods: {
        blurMenu(which) {
            if (this.menu.showTimeout) {
                clearTimeout(this.menu.showTimeout);
                this.menu.showTimeout = null;
            }

            this.menu.hideTimeout = setTimeout(() => {
                this.menu.show =
                    this.menu.show === which ? null : this.menu.show;
            }, 200);
        },
        changeAuthMode(which) {
            this.$store.commit("user/changeAuthMode", which);
        },
        hoverMenu(which) {
            if (this.menu.hideTimeout) {
                clearTimeout(this.menu.hideTimeout);
                this.menu.hideTimeout = null;
            }

            this.menu.showTimeout = setTimeout(() => {
                this.menu.show = which;
            }, 200);
        },
        preventOverscroll(e) {
            let can_scroll_inner = false;

            if (e.target.closest(".vs__dropdown-menu")) {
                //let vsContent = e.target.closest('.vs__dropdown-menu')
                //
                //if ( e.deltaY > 0 ) {
                //    can_scroll_inner = vsContent.scrollTop < vsContent.scrollTopMax
                //} else {
                //    can_scroll_inner = vsContent.scrollTop > 0
                //}

                can_scroll_inner = true;
            } else if (e.target.closest(".simplebar-content")) {
                let sbContent = e.target.closest(".simplebar-content");
                let sbWrapper = e.target.closest(".simplebar-content-wrapper");

                can_scroll_inner =
                    sbContent.scrollHeight > sbWrapper.offsetHeight;
            }

            if (
                (this.$store.getters["modals/modals"].length ||
                    this.$store.getters["account/visible"]) &&
                !can_scroll_inner
            ) {
                e.preventDefault();
                return false;
            }
        },
        toggleSearch() {
            this.search.visible = !this.search.visible;
        },
        handleStripeOnBoardingReturns() {
            // Check for Stripe connect on-boarding returns and navigate (account/navigateTo)
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has("connect")) {
                let page = "profile-payment",
                    pane = "complete-profile",
                    subpage = "index";

                if (
                    urlParams.has("target") &&
                    urlParams.get("target") === "complete" &&
                    this.$store.getters["user/shouldCompleteProfile"]
                ) {
                    page = "profile-payment";
                    pane = "complete-profile";
                    subpage = "index";
                }
                if (
                    urlParams.get("connect") === "return" &&
                    this.$store.getters["user/shouldCompleteProfile"]
                ) {
                    page = "profile-details";
                    pane = "complete-profile";
                    subpage = "index";
                }

                this.$store.commit("account/navigateTo", {
                    page,
                    pane,
                    subpage,
                    data: { connect: urlParams.get("connect") },
                });

                this.clearQueryString();
            }
        },
        handleDirectPanelNavigationQuery() {
            // Direct user to panel (account/navigateTo) based on query string request
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has("go")) {
                switch (urlParams.get("go")) {
                    case "sign-in":
                        if (this.$store.getters["user/account"]) {
                            this.$store.commit("account/open");
                            break;
                        }
                        this.$store.commit("user/changeAuthMode", "login");
                        break;
                    case "list-your-space":
                        if (!this.$store.getters["user/account"]) {
                            this.$store.commit(
                                "user/setShouldBeRedirectedToListingForm",
                                true
                            );
                            this.$store.commit("user/changeAuthMode", "login");
                            break;
                        } else if (this.$store.getters["user/isLister"]) {
                            this.$store.dispatch("modals/showAddListing");
                            break;
                        }
                    case "bookings":
                        if (!this.$store.getters["user/account"]) {
                            this.$store.commit("user/changeAuthMode", "login");
                            break;
                        }
                        this.$store.commit("account/navigateTo", {
                            page: "bookings",
                            pane: "main",
                        });
                        break;
                    case "hirer-tools":
                        window.history.pushState(
                            "state obj or string",
                            "url",
                            window.location.href + "#find-your-space-today"
                        );
                        this.$store.commit("findspace/show");
                        break;
                }

                this.clearQueryString();
            }
        },
        clearQueryString() {
            history.replaceState &&
                history.replaceState(
                    null,
                    "",
                    location.pathname +
                        location.search
                            .replace(/(\?.*)/, "")
                            .replace(/^&/, "?") +
                        location.hash
                );
        },
        handleShowPublicShortlist() {
            // Check if URL is the public shortlist URL
            if(location.pathname.slice(0, 19) == '/shortlists/public/') {
                // Make api call to get decrypted token
                axios.get('/api/public/shortlist/' + location.pathname.slice(19))
                    .then(response => {
                        // Show the findspace shortlist view modal with the
                        // public variation using the decrypted token as the itemId
                        this.$store.commit("findspace/navigateToSubpage", {
                            page: 'shortlists',
                            subpage: 'view',
                            item: response.data,
                            public: true
                        });
                    })
                    .catch(error => {
                        this.$toasted.show(
                            'Shortlist link no longer available', { type: 'error' }
                        )
                    })
            }

            // Check if URL is the public booking URL
            if(location.pathname.slice(0, 17) == '/bookings/public/') {
              // Make api call to get decrypted token
              axios.get('/api/public/booking/' + location.pathname.slice(17))
                  .then(response => {
                      // Show the findspace booking view modal with the
                      // public variation using the decrypted token as the itemId
                      this.$store.commit("findspace/navigateToSubpage", {
                          page: 'bookings',
                          subpage: 'view',
                          item: response.data,
                          public: true
                      });
                  })
                  .catch(error => {
                      this.$toasted.show(
                          'Booking link no longer available', { type: 'error' }
                      )
                  })
            }
        }
    },
});

/**
 * Initial state population
 */
// if (initialState) {
//     if (initialState.user) {
//         store.commit('user/authenticated', initialState.user)
//     }
// }

/**
 * Axios setup
 */

// Add XSRF token to all requests
// if (document.querySelector('meta[name="csrf-token"]')) {
//     axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
// }

// Add auth token to all requests
if (store.getters["user/accessToken"]) {
    store.dispatch("user/setAuthHeader");
}

// Handle not authenticated responses
axios.interceptors.response.use(
    function (response) {
        // Maybe refresh JWT token?
        // TODO we probably don't need this anymore as we have interval refreshes, consider deprecating
        // if (store.getters['user/accessToken']) {
        //     const token = store.getters['user/token'],
        //       expiry = new Date(token.created_at + token.expires_in)
        //
        //     if (expiry <= Date.now()) {
        //         store.dispatch('user/refresh')
        //     }
        // }

        // Update our CSRF token maybe?
        // if (document.querySelector('meta[name="csrf-token"]')) {
        //     if (response.data && response.data.csrfToken) {
        //         $('meta[name="csrf-token"]').attr('content', response.data.csrfToken)
        //         axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken
        //     }
        // }

        return response;
    },
    function (error) {
        // Redirect based on our status code
        switch (error.response.status) {
            // Not authenticated
            case 401:
            case 440:
                // Mark our user as logged out
                store.commit(
                    "user/deAuthenticated",
                    "Your session has expired. Please log in below to pick up where you left off."
                );

                // And if we were showing an account panel, show the login panel
                if (store.getters["account/visible"]) {
                    store.commit("account/hide", true);
                    store.commit("user/changeAuthMode", "login");
                }

                break;
        }

        return Promise.reject(error);
    }
);

// Update our window size when our viewport changes
const updateWindowSize = throttle(
    function (e) {
        store.commit("resizeWindow");
    },
    100,
    { leading: true, trailing: true }
);

window.addEventListener("resize", updateWindowSize);

if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", updateWindowSize);
}
